// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightOutlinedSvg from "@fishx/icons-svg/es/asn/RightOutlined";
import FishxIcon from '../components/FishxIcon';

var RightOutlined = function RightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightOutlinedSvg
  }));
};

RightOutlined.displayName = 'RightOutlined';
export default React.forwardRef(RightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightOutlined.js
// module id = 4022
// module chunks = 0